import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,

} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { DynFormProps } from '../..';
import { useMemo } from 'react';

interface TipoOperacao {
  value: string,
  nome: string
}

export default function DynDocumentRequest({ spec }: DynFormProps) {
  const { control, watch } = useFormContext();

  const acaoSelecionada = watch(`resposta`) || '';

  const tipoOperacaoArray: TipoOperacao[] = [
    { value: "", nome: "Selecione uma opção" },
    { value: "Sem contrato", nome: "Sem contrato" },
    { value: "Contrato de limite de crédito global", nome: "Contrato de limite de crédito global" },
    { value: "Contrato de reserva de domínio", nome: "Contrato de reserva de domínio" },
    { value: "Contrato com nota promissória", nome: "Contrato com nota promissória" },
    { value: "Contrato com garantia hipotecária (REAL)", nome: "Contrato com garantia hipotecária (REAL)" },
    { value: "Contrato com garantia pignoratícia (CPR)", nome: "Contrato com garantia pignoratícia (CPR)" },
    { value: "Contrato com garantia hipotecária e pignoratícia", nome: "Contrato com garantia hipotecária e pignoratícia" },
    { value: "Contrato com garantia de alienação fiduciária", nome: "Contrato com garantia de alienação fiduciária" },
    { value: "Contrato de financiamento de pré-colheita", nome: "Contrato de financiamento de pré-colheita" },
  ]

  const isFieldRequired = (): boolean => {
    return acaoSelecionada === 'Aprovar';
  };

  const initialFormData = useMemo(() => {
    const currentData = watch(spec.name) || {};
    return {
      tipo_operacao: currentData.tipo_operacao || '',
      necessario_avalista: currentData.necessario_avalista || '',
      necessario_registro: currentData.necessario_registro || '',
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch(spec.name)]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Controller
        name={`${spec.name}.tipo_operacao`}
        control={control}
        defaultValue={initialFormData.tipo_operacao}
        rules={{
          validate: (value: string) => {
            if (acaoSelecionada === 'Aprovar') {
              if (!value || value.trim() === '') {
                return 'Campo obrigatório para aprovação';
              }
            }
            return true;
          }
        }}
        render={({ field, fieldState: { error } }) => (
          <FormControl
            fullWidth
            required={isFieldRequired()}
            error={isFieldRequired() ? !!error : false}
          >
            <InputLabel id={`${spec.name}-tipo-operacao-label`}>
              Tipo de operação
            </InputLabel>
            <Select
              labelId={`${spec.name}-tipo-operacao-label`}
              label={`Tipo de operação`}
              value={field.value ?? ''}
              onChange={(e) => field.onChange(e.target.value || '')}
            >
              {tipoOperacaoArray.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.nome}
                </MenuItem>
              ))}
            </Select>
            {error && isFieldRequired() && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                {error.message}
              </Typography>
            )}
          </FormControl>
        )}
      />

      <Controller
        name={`${spec.name}.necessario_avalista`}
        control={control}
        defaultValue={initialFormData.necessario_avalista}
        rules={{
          validate: (value: string) => {
            if (acaoSelecionada === 'Aprovar') {
              if (!value || value.trim() === '') {
                return 'Campo obrigatório para aprovação';
              }
            }
            return true;
          }
        }}
        render={({ field, fieldState: { error } }) => (
          <FormControl
            fullWidth
            required={isFieldRequired()}
            error={isFieldRequired() ? !!error : false}
          >
            <InputLabel id={`${spec.name}-avalista-label`}>
              Necessário avalista?
            </InputLabel>
            <Select
              labelId={`${spec.name}-avalista-label`}
              label={`Necessário avalista?`}
              value={field.value ?? ''}
              onChange={(e) => field.onChange(e.target.value || '')}
            >
              <MenuItem value="">
                <em>Selecione uma opção</em>
              </MenuItem>
              <MenuItem value="Sim">Sim</MenuItem>
              <MenuItem value="Não">Não</MenuItem>
            </Select>
            {error && isFieldRequired() && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                {error.message}
              </Typography>
            )}
          </FormControl>
        )}
      />

      <Controller
        name={`${spec.name}.necessario_registro`}
        control={control}
        defaultValue={initialFormData.necessario_registro}
        rules={{
          validate: (value: string) => {
            if (acaoSelecionada === 'Aprovar') {
              if (!value || value.trim() === '') {
                return 'Campo obrigatório para aprovação';
              }
            }
            return true;
          }
        }}
        render={({ field, fieldState: { error } }) => (
          <FormControl
            fullWidth
            required={isFieldRequired()}
            error={isFieldRequired() ? !!error : false}
          >
            <InputLabel id={`${spec.name}-registro-label`}>
              Necessário registro?
            </InputLabel>
            <Select
              labelId={`${spec.name}-registro-label`}
              label={`Necessário registro?`}
              value={field.value ?? ''}
              onChange={(e) => field.onChange(e.target.value || '')}
            >
              <MenuItem value="">
                <em>Selecione uma opção</em>
              </MenuItem>
              <MenuItem value="Sim">Sim</MenuItem>
              <MenuItem value="Não">Não</MenuItem>
            </Select>
            {error && isFieldRequired() && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                {error.message}
              </Typography>
            )}
          </FormControl>
        )}
      />

    </Box>
  );
}